var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "SFaddi" },
    [
      _setup.props.properties
        ? [
            _c("div", { staticClass: "SFaddi__head" }, [
              _c("div", { staticClass: "SFaddi__head-title" }, [
                _vm._v("Фильтры"),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "SFaddi__head-reset",
                  on: { click: _setup.reset },
                },
                [_vm._v("Сбросить все")]
              ),
            ]),
            _vm._v(" "),
            _c(
              _setup.MyCheckbox,
              {
                staticClass: "SFaddi__igroup",
                attrs: { choosed: _setup.props.choosed.withPlaces },
                on: {
                  input: function ($event) {
                    return _setup.select("withPlaces", $event)
                  },
                },
              },
              [
                _c("span", { staticClass: "SFaddi__title" }, [
                  _vm._v("Только с местами"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyPrice,
              {
                staticClass: "SFaddi__igroup",
                attrs: {
                  list: _vm.properties.minprice,
                  choosedFrom: _setup.props.choosed.minPriceFrom,
                  choosedTo: _setup.props.choosed.minPriceTo,
                },
                on: {
                  input: function ($event) {
                    return _setup.select_price($event)
                  },
                },
              },
              [
                _c("div", { staticClass: "SFaddi__title_price" }, [
                  _vm._v("Цена за одного человека"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyMultiVert,
              {
                staticClass: "SFaddi__igroup",
                attrs: {
                  list: _vm.properties.popularRoutes,
                  choosed: _setup.props.choosed.popularRoutes,
                  placeholder: "...",
                },
                on: {
                  input: function ($event) {
                    return _setup.select("popularRoutes", $event)
                  },
                },
              },
              [
                _c("div", { staticClass: "SFaddi__title" }, [
                  _vm._v("Популярные маршруты"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyMultiVert,
              {
                staticClass: "SFaddi__igroup",
                attrs: {
                  list: _vm.properties.routeCities,
                  choosed: _setup.props.choosed.routeCities,
                  placeholder: "...",
                },
                on: {
                  input: function ($event) {
                    return _setup.select("routeCities", $event)
                  },
                },
              },
              [
                _c("div", { staticClass: "select__title" }, [
                  _vm._v("Города по маршруту"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyMultiVert,
              {
                staticClass: "SFaddi__igroup",
                attrs: {
                  list: _vm.properties.rivers,
                  choosed: _setup.props.choosed.river,
                  placeholder: "...",
                },
                on: {
                  input: function ($event) {
                    return _setup.select("river", $event)
                  },
                },
              },
              [
                _c("div", { staticClass: "select__title" }, [
                  _vm._v(
                    _vm._s(_setup.isSea() ? "Моря" : "Реки / Озера / Моря")
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyCheckbox,
              {
                staticClass: "SFaddi__igroup",
                attrs: { choosed: _setup.props.choosed.is_oneway },
                on: {
                  input: function ($event) {
                    return _setup.select("is_oneway", $event)
                  },
                },
              },
              [
                _c("span", { staticClass: "SFaddi__title" }, [
                  _vm._v("В одну сторону"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyMultiVert,
              {
                staticClass: "SFaddi__igroup",
                attrs: {
                  list: _vm.properties.dps,
                  onlyone: true,
                  limit: 2,
                  choosed: _setup.props.choosed.dps,
                  placeholder: "...",
                },
                on: {
                  input: function ($event) {
                    return _setup.select("dps", $event)
                  },
                },
              },
              [
                _c("div", { staticClass: "select__title" }, [
                  _vm._v("Оператор"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              _setup.MyCheckbox,
              {
                staticClass: "SFaddi__igroup",
                attrs: { choosed: _setup.props.choosed.is_klk },
                on: {
                  input: function ($event) {
                    return _setup.select("is_klk", $event)
                  },
                },
              },
              [
                _c("span", { staticClass: "SFaddi__title" }, [
                  _vm._v("Оплата баллами"),
                ]),
              ]
            ),
          ]
        : [_c(_setup.Loader, { staticClass: "loader" })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }